import React, { useState } from 'react';
import { useLocation, Link } from 'react-router-dom';

export default function Tabbar() {
    const router = useLocation();
    const [menuOpen, setMenuOpen] = useState(false);



    return (
        <div className="tabbar">
            <nav>
                <ul className="tabbar-nav">
                    <li className="tab-item">
                        <Link to="/" className={`${router.pathname === '/' ? 'active' : ''}`}>
                            <span className="icon-wrap">
                                <i className="fa-solid fa-home"></i>
                            </span>
                            <span className="link-name">Home</span>
                        </Link>
                    </li>
                    <li className="tab-item">
                        <Link to="/my-nft-access" className={`${router.pathname === '/my-nft-access' ? 'active' : ''}`}>
                            <span className="icon-wrap">
                                <i className="fa-solid fa-desktop"></i>
                            </span>
                            <span className="link-name">My Utility Items</span>
                        </Link>
                    </li>
                    <li className="tab-item">
                        <Link to="/staked" className={`${router.pathname === '/staked' ? 'active' : ''}`}>
                            <span className="icon-wrap">
                                <i className="fa-solid fa-box-open"></i>
                            </span>
                            <span className="link-name">Access Utility</span>
                        </Link>
                    </li>
                    <li class="tab-item">
                        <button class="tab-more" onClick={() => setMenuOpen(!menuOpen)}>
                            <span class="icon-wrap">
                                <i class="fa fa-light fa-bars"></i>
                            </span>
                            <span class="link-name">More</span>
                        </button>
                    </li>

                </ul>
            </nav>
            {menuOpen &&
                <>
                    <div class="close-tabbar-more"></div>
                    <nav class="tabbar-more">
                        <ul>
                            <li className='my-2'>
                                <a href="https://hengex.io/" target="_blank" rel="noreferrer">
                                    <span className="link-name">Token-Based Access Tools</span>
                                </a>
                            </li>
                            <li className='my-2'>
                                <a href="#sec">
                                    <span className="link-name">Utility Marketplace</span>
                                </a>
                            </li>
                            <li className='my-2'>
                                <a href={`https://bscscan.com/token/0x65bba7bdb1ec1c1a0917c9aa766cd4391182e87d`} target="_blank" rel="noreferrer">
                                    <span className="link-name">Smart Contract</span>
                                </a>
                            </li>
                            <li className='my-2'>
                                <a href="https://www.dextools.io/app/en/bnb/pair-explorer/0x5fff7742c714ea69f6439d19a5629876cff0ad3e?t=1717576408792" target="_blank" rel="noreferrer">
                                    <span className="link-name">Token Activity</span>
                                </a>
                            </li>
                            <li className='my-2'>
                                <a href="https://www.ricesnetwork.com/cbnstaking/" target="_blank" rel="noreferrer">
                                    <span className="link-name">Access Participation Option</span>
                                </a>
                            </li>
                            <li className='my-2'>
                                <a href="https://www.ricesnetwork.com/malistaking/" target="_blank" rel="noreferrer">
                                    <span className="link-name">Utility Access Plan</span>
                                </a>
                            </li>
                            <li className='my-2'>
                                <a href="https://www.ricesnetwork.com/bkrstaking/" target="_blank" rel="noreferrer">
                                    <span className="link-name">Project Documents</span>
                                </a>
                            </li>
                            <li>
                                <a href="https://www.ricesnetwork.com/wrstaking/" target="_blank" rel="noreferrer">
                                    <span className="link-name">WR Staking</span>
                                </a>
                            </li>
                        </ul>
                    </nav>
                </>
            }


        </div>
    )
}
